import React, { useEffect, useRef, useState } from "react";
import FroalaEditor from "react-froala-wysiwyg";
// CSS (make sure your bundler loads these)
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins.pkgd.min.js"; // All plugins

import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import FileInput from "../../../../components/common/ui/Inputs/FileInput";
import Button from "../../../../components/common/ui/Button";
import { history } from "../../../../_helpers";
import { useSelector, useDispatch } from "react-redux";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import Swal from "sweetalert2";
import { menuActions } from "../../../../_store/menu.slice";
import MenuPageIntegrationSchema from "../../../../validation/Admin/menuIntegrationSchema";
import { useLocation } from "react-router-dom";
import { config } from "../../Editor_Config/Froalaconfig";
import CustomLoader from "../../../../components/common/ui/Loader";

const MenuIntegration = () => {
  const dispatch = useDispatch();
  const isFirstRender = useRef(true);

  const [errorMessage, setErrorMessage] = useState({});

  const location = useLocation();

  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;
  const [isPending, setIsPending] = useState(false);
  const { menuData, loading } = useSelector((x) => x.menu);
  const MenuResData = useSelector((x) => x?.menu?.getMenuResponseData?.data);
  const item = location?.state?.item;

  // get the data for Page using Url slug
  useEffect(() => {
    if (!item) return;
    dispatch(menuActions.getMenuData(item?.url));
  }, [item]);

  // After get the page data response from Api update it into redux state
  useEffect(() => {
    if (!MenuResData) return;
    let data = { ...MenuResData };
    data["fileCheck"] = MenuResData?.bannerImage;
    dispatch(menuActions.updateMenuData(MenuResData));
  }, [MenuResData]);

  // const config = {
  //   // key: `${process.env.REACT_APP_API_Froala_Key}`, // Key for Froala
  //   placeholderText: "Start typing...",
  //   charCounterCount: true,
  //   toolbarButtons: [
  //     "bold",
  //     "italic",
  //     "underline",
  //     "strikeThrough",
  //     "subscript",
  //     "superscript",
  //     "|",
  //     "fontFamily",
  //     "fontSize",
  //     "color",
  //     "inlineStyle",
  //     "paragraphStyle",
  //     "|",
  //     "paragraphFormat",
  //     "align",
  //     "formatOL",
  //     "formatUL",
  //     "outdent",
  //     "indent",
  //     "quote",
  //     "|",
  //     "insertLink",
  //     "insertImage",
  //     "insertVideo",
  //     "insertFile",
  //     "insertTable",
  //     "|",
  //     "emoticons",
  //     "specialCharacters",
  //     "embedly",
  //     "insertHR",
  //     "selectAll",
  //     "clearFormatting",
  //     "|",
  //     "print",
  //     "spellChecker",
  //     "help",
  //     "html",
  //     "|",
  //     "undo",
  //     "redo",
  //   ],
  //   tableClass: "table table-bordered table-responsive", // 👈 auto-apply
  //   tableStyles: {
  //     "table-bordered": "Bordered",
  //     "table-striped": "Striped",
  //     "table-responsive": "Responsive",
  //   },
  //   tableEditButtons: [
  //     "tableHeader",
  //     "tableRemove",
  //     "tableRows",
  //     "tableColumns",
  //     "tableStyle",
  //     "tableCellBackground",
  //     "tableCellStyles",
  //     "tableMerge",
  //     "tableSplit",
  //   ],
  //   // pluginsEnabled: [
  //   //   "table",
  //   //   "align",
  //   //   "colors",
  //   //   "link",
  //   //   "image",
  //   //   "file",
  //   //   "video",
  //   // ],

  //   toolbarButtonsXS: null,
  //   toolbarButtonsSM: null,
  //   toolbarButtonsMD: null,
  //   imageUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,
  //   // `

  //   // Video upload endpoint (if needed)
  //   videoUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // File upload endpoint
  //   fileUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // Extra settings
  //   imageUploadParam: "file", // 👈 match multer field name
  //   fileUploadParam: "file",
  //   videoUploadParam: "file",
  //   events: {
  //     "image.uploaded": function (response) {
  //       const res = JSON.parse(response);
  //       debugger;
  //       if (res.link) {
  //         this.image.insert(
  //           `${process.env.REACT_APP_API_IMAGE_URL}${res.link}`, // ✅ use IMAGE_URL, not API_URL
  //           true,
  //           null,
  //           this.image.get(),
  //           response
  //         );
  //         return false; // prevent Froala default insert
  //       }
  //     },
  //   },

  //   // Example: image upload endpoint on your server

  //   // Additional options you might use:
  //   // imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  //   // fileUploadURL: '/api/uploads/froala-file',
  //   //
  // };

  useEffect(() => {
    Swal.close();
  }, []);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  const handleFroalaEditorChanges = (content, name) => {
    if (isFirstRender.current) return;
    const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");

    const payload = { ...menuData };
    payload[name] = cleanedContent;

    dispatch(menuActions.updateMenuData(payload));
  };

  const handleChange = (e, nameToShow) => {
    let pageData = { ...menuData };
    const { name, value, type } = e?.target;
    if (type === "file") {
      const file = e.target.files[0];
      // const formData = new FormData();
      // formData.append("image", file);
      // onFileSelect(file);
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        pageData["bannerImagetoShow"] = imageUrl;
        pageData["bannerImage"] = file;
        pageData["fileCheck"] = file
          ? { name: file.name, type: file.type || "" }
          : undefined;
      }
      dispatch(menuActions?.updateMenuData(pageData));
      return;
    }
    pageData[name] = value;

    dispatch(menuActions?.updateMenuData(pageData));
  };

  const submitHomeTabContent = (e) => {
    setErrorMessage({});
    e?.preventDefault();
    setIsPending(true);
    const formData = new FormData();
    Object.keys(menuData).forEach((key) => {
      if (menuData[key] !== undefined && menuData[key] !== null) {
        if (key === "descriptionOne") {
          formData.append(key, menuData?.descriptionOne);
        } else if (key === "descriptionTwo") {
          formData.append(key, menuData?.descriptionTwo);
        } else {
          formData.append(key, menuData[key]);
        }
      }
    });

    const { error } = MenuPageIntegrationSchema(menuData);

    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    dispatch(
      menuActions.updateMenuPage({ id: menuData?._id, params: formData }),
    )
      .then((result) => {
        if (result?.payload?.status === 1) {
          setIsPending(false);
          showToastNotification(result?.payload?.message, "success");
          history.navigate("/Admin/Menu");
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch(() => {
        setIsPending(false);
        showToastNotification("Something went wrong", "error");
      });
  };

  const handleReset = (e) => {
    e?.preventDefault();

    // dispatch(menuActions.resetData());
    dispatch(menuActions.getMenuData(item?.url));
  };

  if (loading) return <CustomLoader />;
  return (
    <div>
      <form
        onSubmit={(e) => {
          submitHomeTabContent(e);
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="header-color">Create Page</h1>
          <Button
            label="Back"
            status="reset"
            onClick={() => {
              history?.navigate("/Admin/Menu");
            }}
          />
        </div>

        {/* Banner */}
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            Banner
          </h1>
          <div className="p-3 row">
            <div className="row mb-4">
              <div className="col-md-4">
                <TextInput
                  name="title"
                  id="title"
                  label="Title"
                  placeholder="Title"
                  handleChange={(e) => {
                    handleChange(e, "title");
                  }}
                  required
                  value={menuData?.title}
                  errorMessage={errorMessage}
                  maxLength={200}
                />
              </div>
              <div className="col-md-4 d-flex">
                <FileInput
                  name="fileCheck"
                  label="Banner Image"
                  // imageURL={
                  //   committeeHomePage?.committeeBannerImageToShow === undefined
                  //     ? ImageURL + committeeHomePage?.committeeBannerImage
                  //     : committeeHomePage?.committeeBannerImageToShow
                  // }
                  imageURL={
                    menuData?.bannerImagetoShow === undefined
                      ? ImageURL + menuData?.bannerImage
                      : menuData?.bannerImagetoShow
                  }
                  handleFileChange={(e) => {
                    handleChange(e, "bannerImage");
                  }}
                  required
                  errorMessage={errorMessage}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Session- 1 */}
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            {/* Section - 1 */}
            Description
          </h1>
          <div className="p-3 row">
            <div className="row mb-4">
              <div className="col-md-12">
                <FroalaEditor
                  tag="textarea"
                  name="descriptionOne"
                  config={config} // your toolbar, plugins, etc.
                  model={menuData?.descriptionOne || ""} // ✅ value binding
                  onModelChange={(content) => {
                    // ✅ onChange equivalent
                    handleFroalaEditorChanges(content, "descriptionOne");
                  }}
                  className={`editor-block ${
                    errorMessage?.["descriptionOne"] ? "input-error" : ""
                  }`}
                />

                {errorMessage?.descriptionOne && (
                  <div className="text-danger fw-700 fs-6 mt-1">
                    {errorMessage?.descriptionOne}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* {description} */}
        {/* <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            Description
          </h1>
          <div className="p-3 row">
            <div className="row mb-4">
              <div className="col-md-12">
                <FroalaEditor
                  tag="textarea"
                  name="descriptionTwo"
                  config={config} // your toolbar, plugins, etc.
                  model={menuData?.descriptionTwo || ""} // ✅ value binding
                  onModelChange={(content) => {
                    // ✅ onChange equivalent
                    handleFroalaEditorChanges(content, "descriptionTwo");
                  }}
                  className={`editor-block ${
                    errorMessage?.["descriptionTwo"] ? "input-error" : ""
                  }`}
                />

                {errorMessage?.descriptionTwo && (
                  <div className="text-danger fw-700 fs-6 mt-1">
                    {errorMessage?.descriptionTwo}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div> */}
        <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
          <Button
            label="Submit"
            status="primary"
            type="submit"
            disabled={isPending}
          />
          <Button
            label="Reset"
            status="reset"
            type="reset"
            onClick={() => {
              handleReset();
            }}
          />
        </div>
      </form>
    </div>
  );
};

export default MenuIntegration;
